 import { Link } from 'react-router-dom';
 import { Clock, Home, LogOut, Mail, RefreshCw } from 'lucide-react';
 import { Button } from '@/components/ui/button';
 import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
 import { supabase } from '@/integrations/supabase/client';
 import { useNavigate } from 'react-router-dom';
 
 /**
  * Dealer Pending Approval Page
  * Shown when a dealer user's organization is still pending approval.
  * 
  * This is distinct from:
  * - DealerSuspendedPage (org was approved but is now suspended)
  * - DealerMemberInactivePage (org is approved but member is inactive)
  */
 export function DealerPendingPage() {
   const navigate = useNavigate();
   
   const handleSignOut = async () => {
     await supabase.auth.signOut();
     navigate('/dealer/login');
   };
 
   const handleRefresh = () => {
     window.location.reload();
   };
   
   return (
     <div className="min-h-screen flex items-center justify-center bg-background p-4">
       <Card className="max-w-md w-full">
         <CardHeader className="text-center pb-2">
           <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-warning/10 flex items-center justify-center">
             <Clock className="h-8 w-8 text-warning" />
           </div>
           <CardTitle className="text-2xl">Account Pending Approval</CardTitle>
           <CardDescription className="text-base">
             Your dealer account is awaiting approval
           </CardDescription>
         </CardHeader>
         <CardContent className="space-y-4">
           <p className="text-sm text-muted-foreground text-center">
             Thank you for registering! Our team is reviewing your application and will notify you by email once your account is approved.
           </p>
           
           <div className="bg-muted/50 rounded-lg p-4 text-sm">
             <p className="font-medium mb-2">What happens next?</p>
             <ul className="list-disc list-inside space-y-1 text-muted-foreground">
               <li>We'll verify your dealership information</li>
               <li>You'll receive an email notification</li>
               <li>Approval typically takes 1-2 business days</li>
             </ul>
           </div>
           
           <div className="flex flex-col gap-3 pt-4">
             <Button variant="outline" onClick={handleRefresh} className="w-full">
               <RefreshCw className="h-4 w-4 mr-2" />
               Check Status
             </Button>
             
             <Button asChild variant="ghost" className="w-full">
               <Link to="/">
                 <Home className="h-4 w-4 mr-2" />
                 Go to Homepage
               </Link>
             </Button>
             
             <Button variant="ghost" onClick={handleSignOut} className="w-full">
               <LogOut className="h-4 w-4 mr-2" />
               Sign Out
             </Button>
           </div>
           
           <div className="flex items-center justify-center gap-2 pt-4 text-xs text-muted-foreground">
             <Mail className="h-3 w-3" />
             <span>Questions? <a href="mailto:dealers@geargossip.com" className="underline hover:text-primary">Contact Dealer Support</a></span>
           </div>
         </CardContent>
       </Card>
     </div>
   );
 }